(() => {
  'use strict';
  const setup = root => {
    if (root.dataset.ach34Ready) return;
    const q = selector => root.querySelector(selector), search = q('[data-ach22-search]'), track = q('[data-ach34-more]'), all = q('[data-ach34-all]');
    if (!search || !track || !all) return;
    let words; try { words = JSON.parse(q('[data-ach34-copy]').textContent); } catch { return; }
    root.dataset.ach34Ready = 'true';
    const life = new AbortController(), events = { signal: life.signal }, cards = [...root.querySelectorAll('[data-ach34-card]')];
    const normal = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const profile = document.querySelector('#shopify-section-itp-header-v21 .lux25-header-apply');
    const original = { placeholder: search.placeholder, profileText: profile?.textContent, profileHref: profile?.getAttribute('href') };
    const landing = () => root.dataset.gallery26State !== 'detail';
    const motion = () => document.documentElement.dataset.motion !== 'off' && (!matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.dataset.motionChoice === 'on');
    const steps = () => {
      const expanded = track.dataset.expanded === 'true';
      root.querySelector('[data-ach34-step="-1"]').disabled = expanded || track.scrollLeft < 3;
      root.querySelector('[data-ach34-step="1"]').disabled = expanded || track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    };
    const filter = () => {
      if (!landing()) return;
      const value = normal(search.value), terms = value.split(/\s+/).filter(Boolean);
      let matches = 0;
      cards.forEach(card => { const label = normal(card.querySelector('h3').textContent); const match = !terms.length || terms.every(term => label.includes(term)); card.hidden = !match; if (match) matches++; });
      root.dataset.ach34SearchMode = value && matches ? 'categories' : 'people';
      q('[data-ach34-empty]').hidden = !value || !!matches;
      if (value) track.dataset.expanded = 'true'; else track.dataset.expanded = all.getAttribute('aria-expanded');
      steps();
    };
    let lastState;
    const state = () => {
      const nextState = landing(); if (nextState === lastState) return; lastState = nextState;
      search.placeholder = landing() ? words.search : original.placeholder;
      if (profile) { profile.textContent = landing() ? words.profile : original.profileText; profile.setAttribute('href', landing() ? words.profileUrl : original.profileHref); }
      search.value = '';
      search.dispatchEvent(new Event('input', { bubbles: true }));
      cards.forEach(card => { card.hidden = false; });
      q('[data-ach34-empty]').hidden = true;
      steps();
    };
    search.addEventListener('input', filter, events);
    root.addEventListener('click', event => {
      if (event.target.closest('[data-ach22-clear]')) filter();
      const step = event.target.closest('[data-ach34-step]');
      if (step) track.scrollBy({ left: Number(step.dataset.ach34Step) * track.clientWidth * .85, behavior: motion() ? 'smooth' : 'auto' });
      if (event.target.closest('[data-ach34-all]')) {
        const expanded = all.getAttribute('aria-expanded') !== 'true';
        all.setAttribute('aria-expanded', String(expanded));
        all.childNodes[0].textContent = expanded ? words.less : words.all;
        track.dataset.expanded = String(expanded); steps();
        if (expanded) track.scrollIntoView({ behavior: motion() ? 'smooth' : 'auto', block: 'center' });
      }
    }, events);
    q('[data-ach22-search-form]').addEventListener('submit', () => { if (landing() && root.dataset.ach34SearchMode === 'categories') cards.find(card => !card.hidden)?.focus(); }, events);
    track.addEventListener('scroll', steps, { passive: true, signal: life.signal });
    const observer = new MutationObserver(state); observer.observe(root, { attributes: true, attributeFilter: ['data-gallery26-state'] });
    const resize = new ResizeObserver(steps); resize.observe(track);
    document.addEventListener('shopify:section:unload', event => { if (!event.target.contains(root)) return; life.abort(); observer.disconnect(); resize.disconnect(); if (profile) { profile.textContent = original.profileText; profile.setAttribute('href', original.profileHref); } }, events);
    state();
  };
  document.querySelectorAll('.ach34').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ach34').forEach(setup));
})();
